  <div class="step-preview">
    <div class="step-preview-buttons">
      <div class="step-preview-buttons-fr">
        <button  class="button-icon size-m primary-button"
          (click)="signCreditLetter()"
          [disabled]="
            this.isRoadMapCurrent === false ||
            CONTRACT_STATUSES_TO_SIGN.includes(this.contractData?.contract?.contract.status)===false||
            formState==='Submitting'||
            !isMemberSigner||
            this.isMemberSigner && ['SERVICE_NOT_AVAILABLE'].includes(contractStep.target?.target_status)|| 
            !this.isMemberSigner && ['NO_MONEY','SERVICE_NOT_AVAILABLE'].includes(contractStep.target?.target_status) "
          >
            <mat-icon [svgIcon]="stepIsSignedByMember? 'arrow-go-back-fill' : 'checkbox-multiple-fill' "> </mat-icon>
            <span>
              {{(this.stepIsSignedByMember? 'CONTRACTS.CARD.RECALL' : 'CONTRACTS.CARD.APPROVE') |translate}}
            </span>
        </button>
        <button  class="button-icon size-m secondary-button" (click)="viewCreditLetter()"  >
          <mat-icon svgIcon="file-search-fill" > </mat-icon>
          <span>
            {{'CONTRACTS.CARD.VIEW'|translate}}
          </span>
        </button>
      </div>
    </div>
    <div class="step-preview-parties" *ngIf="contractAvatarsService?.contractAvatarMap">
      <div class="step-preview-parties-signed" *ngIf="singedMembers?.length">
        <div class="step-preview-parties-title">{{'CONTRACTS.CARD.APPROVED'| translate}}</div>
        <div class="step-preview-parties-signed-users" >
        <app-contract-avatar *ngFor="let guid of singedMembers"
          [avatarSize]="'42px'"
          [userGuid]="guid" 
          [checkedState]="true">
        </app-contract-avatar>
        </div> 
      </div>
      <div class="step-preview-parties-not_signed" *ngIf="notSingedMembers?.length">
        <div class="step-preview-parties-title">{{'CONTRACTS.CARD.NOT_APPROVED'| translate}}</div>
          <div class="step-preview-parties-not_signed-users" >
            <app-contract-avatar *ngFor="let guid of notSingedMembers"
              [avatarSize]="'42px'"
              [userGuid]="guid" 
              [checkedState]="false">
            </app-contract-avatar>
          </div>
      </div>
    </div>
  </div>
